const adminModal = islogout => {
  return {
    type: "logoutmodal",
    islogout
  };
};

export default adminModal;
